import { useTranslate } from "@similarweb/i18n-provider";
import { ArrowRight } from "@similarweb/icons";

import { ONBOARDING_AGENT_MESSAGE_FOLLOW_UP_QUESTIONS } from "../texts";

import {
    FollowUpIconWrapper,
    FollowUpItem,
    FollowUpItemText,
    FollowUpsLabel,
    FollowUpsList,
    FollowUpsSection,
} from "./styles";

export type OnboardingAgentAssistantFollowUpsProps = {
    readonly messageIndex: number;
    readonly questions: readonly string[];
    readonly isDisabled?: boolean;
    readonly onAskFollowUp: (question: string) => void;
};

export const OnboardingAgentAssistantFollowUps = ({
    messageIndex,
    questions,
    isDisabled = false,
    onAskFollowUp,
}: OnboardingAgentAssistantFollowUpsProps) => {
    const { translate } = useTranslate();

    if (questions.length === 0) {
        return null;
    }

    return (
        <FollowUpsSection data-automation={`onboarding-agent-message-${messageIndex}-follow-ups`}>
            <FollowUpsLabel data-automation={`onboarding-agent-message-${messageIndex}-follow-ups-label`}>
                {translate(ONBOARDING_AGENT_MESSAGE_FOLLOW_UP_QUESTIONS)}
            </FollowUpsLabel>
            <FollowUpsList>
                {questions.map((question, chipIndex) => {
                    const automation = `onboarding-agent-message-${messageIndex}-follow-up-${chipIndex}`;
                    const handleClick = (): void => {
                        if (isDisabled) {
                            return;
                        }

                        onAskFollowUp(question);
                    };

                    return (
                        <FollowUpItem
                            key={`${question}-${chipIndex}`}
                            type="button"
                            data-automation={automation}
                            disabled={isDisabled}
                            onClick={handleClick}
                        >
                            <FollowUpIconWrapper aria-hidden="true">
                                <ArrowRight size={20} color="currentColor" />
                            </FollowUpIconWrapper>
                            <FollowUpItemText>{question}</FollowUpItemText>
                        </FollowUpItem>
                    );
                })}
            </FollowUpsList>
        </FollowUpsSection>
    );
};
